import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ProfitLog } from "../../types/profitLog.type";
import { api } from "../../api/api";
import { message, Table, Typography } from "antd";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

const { Title } = Typography;

export default function Logs() {
  const { startDate, endDate } = useParams();
  const [logs, setLogs] = useState<ProfitLog[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchLogs = async () => {
    setLoading(true);

    try {
      const response = await api.get(`/stats/logs`, {
        params: {
          startDate,
          endDate,
        },
      });

      setLogs(response.data);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение инвестиций.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [startDate, endDate]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Сумма USD",
      key: "amountUSD",
      render: (record: ProfitLog) => roundToThreeDecimals(record.amount.USD),
    },
    {
      title: "Общ.Прибыль до",
      dataIndex: "netProfitBefore",
      key: "netProfitBefore",
      render: (data: number) => roundToThreeDecimals(data),
    },
    {
      title: "Общ.Прибыль после",
      dataIndex: "netProfitAfter",
      key: "netProfitAfter",
      render: (data: number) => roundToThreeDecimals(data),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>
        Прыбиль Печка {startDate} - {endDate}
      </Title>

      <Table
        loading={loading}
        columns={columns}
        dataSource={logs}
        rowKey={(record) => record._id}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
